"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var shadows_1 = __importDefault(require("../../../styles/config/shadows"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var ColoredCard_logic_1 = require("./ColoredCard.logic");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var color = _a.color, isActive = _a.isActive, hasDarkBorder = _a.hasDarkBorder, isExpanded = _a.isExpanded;
            return ({
                borderRadius: 4,
                border: '2px solid',
                borderColor: (0, ColoredCard_logic_1.getBorderColor)(color, isActive, hasDarkBorder, isExpanded),
                padding: '22px 20px 16px',
                backgroundColor: (0, ColoredCard_logic_1.getBackgroundColor)(color, isActive, isExpanded),
                position: 'relative',
                boxShadow: shadows_1.default.weak,
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: -2,
                    left: -2,
                    height: 6,
                    width: 'calc(100% + 4px)',
                    backgroundColor: color,
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                },
            });
        },
        rootHover: {
            '&:hover': {
                cursor: 'pointer',
                boxShadow: shadows_1.default.strong,
            },
        },
        header: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            marginRight: 12,
        },
        title: {},
        hoverDefault: function (_a) {
            var color = _a.color, isActive = _a.isActive;
            return ({
                '$root:hover &': {
                    color: "".concat((0, ColoredCard_logic_1.getHoverColor)(color, isActive), " !important"),
                    '& path': {
                        fill: (0, ColoredCard_logic_1.getHoverColor)(color, isActive),
                    },
                },
            });
        },
        chevron: function (_a) {
            var isActive = _a.isActive, color = _a.color, hasDarkBorder = _a.hasDarkBorder, isExpanded = _a.isExpanded;
            return ({
                backgroundColor: hasDarkBorder && !isActive && !isExpanded ? theme_1.default.colors.dark : 'white',
                borderRadius: '50%',
                width: 20,
                height: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: shadows_1.default.medium,
                margin: 'auto',
                marginTop: -12,
                cursor: 'pointer',
                border: '2px solid',
                borderColor: isActive ? color : theme_1.default.colors.globalBackgroundLight,
                position: 'relative',
                boxSizing: 'content-box',
                '&:hover': {
                    boxShadow: shadows_1.default.strong,
                },
            });
        },
    });
});
